var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTlg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#ACB1B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01869 11.6467C9.11944 10.2957 11.1871 9.40509 12.2216 8.97479C15.1755 7.74618 15.7893 7.53276 16.1893 7.52571C16.2773 7.52416 16.4741 7.54597 16.6015 7.64937C16.7091 7.73669 16.7387 7.85464 16.7529 7.93742C16.767 8.0202 16.7847 8.20879 16.7707 8.35614C16.6106 10.038 15.918 14.1195 15.5656 16.0032C15.4165 16.8003 15.1229 17.0675 14.8387 17.0937C14.221 17.1505 13.752 16.6855 13.1537 16.2933C12.2176 15.6797 11.6887 15.2977 10.78 14.6988C9.72988 14.0068 10.4107 13.6265 11.0091 13.0049C11.1658 12.8422 13.8873 10.3668 13.9399 10.1422C13.9465 10.1141 13.9526 10.0094 13.8904 9.95415C13.8283 9.89888 13.7365 9.91778 13.6702 9.93281C13.5763 9.95412 12.0808 10.9426 9.1837 12.8982C8.75921 13.1897 8.37471 13.3317 8.03022 13.3243C7.65044 13.3161 6.91991 13.1096 6.37683 12.933C5.71072 12.7165 5.18131 12.602 5.22741 12.2343C5.25142 12.0428 5.51518 11.8469 6.01869 11.6467Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlg);
export default __webpack_public_path__ + "static/media/tlg.17d271332eb0009b086641ed402b621e.svg";
export { ForwardRef as ReactComponent };